import React, { useEffect } from "react"
import { FormStep } from "@theguarantors/ui-kit-v2"
import { Box } from "@theguarantors/ui-kit-v2/dist/design-system/typography"
import { ThumbsUpIcon } from "./NoApartmentForm.styles"

export function NoApartmentSuccessPage() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Box display="flex" flexDirection="column" data-testid="thankyou-page">
      <Box>
        <ThumbsUpIcon />
      </Box>
      <FormStep.Title>Thanks for contacting us about finding an apartment!</FormStep.Title>
      <FormStep.Subtitle as="p" mt="0">
        Someone from our team will reach out to the email you provided.
      </FormStep.Subtitle>
    </Box>
  )
}
